import useMutationApi from 'src/api/useMutationApi';

type UpdateableField =
  | 'purchaseOrderNumber'
  | 'orderDate'
  | 'deliveryDate'
  | 'shipDate'
  | 'totalAmount'
  | 'currency'
  | 'shipToLocationId'
  | 'billToLocationId'
  | 'buyingPartyLocationId'
  | 'warehouse'
  | 'orderType'
  | 'shippingMethod'
  | 'freightTerms';

interface UpdateFieldData {
  field: UpdateableField;
  value: string | number | Date | null | { id: number; name: string };
}

const useUpdateSalesOrderDraftField = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
) => {
  return useMutationApi<UpdateFieldData>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/field`,
    method: 'PATCH',
    options: {
      onSuccess,
    },
  });
};

export default useUpdateSalesOrderDraftField;
